export default __webpack_public_path__ + "static/media/Triton entrance.23aee0c0.jpg";